module.exports = __webpack_public_path__ + "img/clock-icon.9e9f74d2.svg";